import { useState, type ReactNode } from 'react';
import { MapSidebarContainer } from 'components/MapPage/MapSidebarComponents';
import { useUscgMapContext } from './CorporateViewTabs/LayersTab/UscgMapContext';
import { UscgMapContainer } from './UscgMapContainer';

type UscgMapLayoutProps = {
  children: ReactNode;
};

export function UscgMapLayout({ children }: UscgMapLayoutProps) {
  const [isMainSidebarVisible, setIsMainSidebarVisible] = useState(true);
  const { isMapVisible } = useUscgMapContext();

  if (!isMapVisible) {
    return <>{children}</>;
  }

  return (
    <div className="d-flex h-100" style={{ overflow: 'hidden' }}>
      <MapSidebarContainer
        isMainSidebarVisible={isMainSidebarVisible}
        setIsMainSidebarVisible={setIsMainSidebarVisible}
      >
        {children}
      </MapSidebarContainer>
      <UscgMapContainer />
    </div>
  );
}
